import { render, staticRenderFns } from "./MortgageSurveyCard.vue?vue&type=template&id=963b188a"
import script from "./MortgageSurveyCard.vue?vue&type=script&lang=js"
export * from "./MortgageSurveyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports